import Papa from 'papaparse';
import { Transaction } from '../types/transaction';

export const parseCSV = (file: File): Promise<Transaction[]> => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        try {
          console.log('CSV Headers:', results.meta.fields);
          console.log('First row of data:', results.data[0]);

          const transactions: Transaction[] = results.data.map((row: any) => {
            const amount = parseFloat(row.amount || row.Amount || row.AMOUNT || '0');
            const balance = parseFloat(row.balance || row.Balance || row.BALANCE || '0');
            
            if (isNaN(amount)) {
              console.warn('Invalid amount found:', row);
            }
            if (isNaN(balance)) {
              console.warn('Invalid balance found:', row);
            }

            const transaction = {
              date: row.date || row.Date || row.DATE || '',
              amount: isNaN(amount) ? 0 : amount,
              merchant: row.merchant || row.Merchant || row.MERCHANT || row.description || row.Description || row.DESCRIPTION || '',
              category: row.category || row.Category || row.CATEGORY || 'Uncategorized',
              description: row.description || row.Description || row.DESCRIPTION || '',
              currency: row.currency || row.Currency || row.CURRENCY || 'USD',
              type: row.type || row.Type || row.TYPE || 'debit',
              balance: isNaN(balance) ? 0 : balance,
              state: row.state || row.State || row.STATE || 'completed'
            };

            console.log('Parsed transaction:', transaction);
            return transaction;
          });

          console.log(`Successfully parsed ${transactions.length} transactions`);
          resolve(transactions);
        } catch (error) {
          console.error('Error parsing CSV:', error);
          reject(new Error('Failed to parse CSV: ' + error));
        }
      },
      error: (error) => {
        console.error('Papa Parse error:', error);
        reject(new Error('Failed to parse CSV: ' + error));
      }
    });
  });
};
